"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
function coerceValueToBoolean(value) {
    if (!lodash_1.isString(value)) {
        return value ? true : false;
    }
    value = value.toLowerCase();
    if (value === '' ||
        value === 'no' ||
        value === 'off' ||
        value === 'false' ||
        value === '0') {
        return false;
    }
    return true;
}
exports.default = coerceValueToBoolean;
